module.exports = __webpack_public_path__ + "img/logo.e270345e.svg";